import { render, staticRenderFns } from "./InventoryEventsDetail.vue?vue&type=template&id=49b4fb1d"
import script from "./InventoryEventsDetail.vue?vue&type=script&lang=js"
export * from "./InventoryEventsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports